/** Hidden UUID filter column of every row-detail grid. */
export const ARTICLE_ID_FILTER_KEY = 'articleId';
